import type { IntlFormatters } from "@formatjs/intl/src/types";
import { isType } from "forms/helpers/checkJsonSchemaType";
import type { IProperty } from "types/jsonSchema";
import { z } from "zod";

const transformEnum = (value: string | number, isNumber: boolean, isNullable: boolean) => {
    if (isNullable && value === "null") {
        return null;
    }

    return isNumber ? Number(value) : value;
};

export default function parseEnum(field: IProperty, formatMessage: IntlFormatters["formatMessage"]) {
    const isNumber = isType(field.type, "integer");
    const isNullable = isType(field.type, "null");

    if (!field.enum || field?.enum.length === 0) {
        return z.never();
    }

    if (field.enum.length === 1) {
        return z
            .literal(field.enum[0].toString(), {
                error: formatMessage({ id: "errors.custom" }),
            })
            .transform((value) => transformEnum(value, isNumber, isNullable));
    }

    return z
        .enum(field.enum.map((item) => JSON.stringify(item)) as unknown as readonly [string, ...string[]])
        .transform((value) => transformEnum(value, isNumber, isNullable));
}
